import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { bindActionCreators } from 'redux';

import { connect } from 'react-redux';

import Form, { FormRow, FormControl } from 'rebook/apps/base/components/form/Form';
import FormTextInput from 'rebook/apps/base/components/form/FormTextInput';
import fetchQuery from 'rebook/apps/utils/fetchQuery';
import Button from 'rebook/apps/base/components/Button';
import validateForm from 'rebook/apps/base/components/form/validateForm';

import { pop } from 'rebook/apps/users/actions/NotificationActions';
import * as BookDetailActions from 'rebook/apps/books/actions/BookDetailActions';

import { NEW_SHELVES_ERROR_MESSAGES } from './constants';

import styles from './style.scss';


class NewShelveDialog extends Component {
  constructor(props) {
    super(props);

    this.state = {
      form: {},
      errorList: {},
      isDisabled: false,
      isInProgress: false,
      response: {},
    };
  }

  componentDidMount() {
    this.nameInput.focus();
  }

  updateFormField(input) {
    this.setState(
      (prevState) => {
        return {
          errorList: {},
          form: {
            ...prevState.form,
            ...input,
          },
        };
      },
    );
  }

  addBookToShelve(response) {
    const { bookId, book } = this.props;
    const url = `/api/bookshelf/${response.id}/bookusershelf/`;
    const params = {
      json: {
        book: `/api/books/${bookId}/`,
      },
      apiVersion: 5,
      method: 'POST',
    };
    fetchQuery(url, params).then(() => {
      let responseShelveName = response.name;
      if (responseShelveName && responseShelveName.length > 100) {
        responseShelveName = responseShelveName.slice(0, 100) + '...';
      }
      const isAudioBook = book.type === 'audio';
      const popupMessage = {
        message: `${isAudioBook ? 'Аудиокнига' : 'Книга'} добавлена на полку "${responseShelveName}" `,
        type: 'thumbsUp',
      };
      const { message, type } = popupMessage;
      this.props.pop(message, type);
      document.querySelector('body').classList.remove('isNotScrollable');
      this.props.onClosePopup();
      this.props.closeModal();
      this.props.BookDetailActions.fetchBookUserBookshelf(book);
    }).catch((error) => {
      throw new Error(error);
    });
  }


  handleSubmit(submit) {
    const form = validateForm(this.state.form);

    if (form.errorList) {
      this.handleError(form.errorList);

      return;
    }

    submit(form);
    this.setState({
      errorList: {},
      isInProgress: true,
    });
  }

  handleSuccess(response) {
    ga('send', 'event', {
      eventCategory: 'Shelves',
      eventAction: 'CreateShelf',
      eventLabel: this.props.gaEventLabel,
    });
    yaMetrikaReachGoal('CreateShelf');

    if (this.props.bookId) {
      this.addBookToShelve(response);
    }
    else {
      document.querySelector('body').classList.remove('isNotScrollable');
      this.props.closeModal();
    }
    this.setState({ isInProgress: false });
  }

  handleError(errorList) {
    if (errorList.error) {
      return (
        this.setState({
          errorList: { name: [errorList.error.slice(6, -1)] },
          isInProgress: false,
        })
      );
    }
    this.setState({
      errorList,
      isInProgress: false,
    });
    this.nameInput.focus();
    if (errorList.non_field_errors) {
      this.props.NotificationActions.pop(errorList.non_field_errors, 'error');
    }
  }

  render() {
    const { errorList, isDisabled, isInProgress } = this.state;

    return (
      <React.Fragment>
        <Form
          action="/api/bookshelf/"
          method="post"
          extraClassName={classNames('jest-week-offer-form', styles.form)}
          onSubmit={(callback) => this.handleSubmit(callback)}
          onSuccess={(data) => this.handleSuccess(data)}
          onError={(errorList) => this.handleError(errorList)}>
          <FormRow>
            <h2 className={styles.header}>Создание полки</h2>
            <FormTextInput
              ref={(input) => {
                this.nameInput = input;
              }}
              extraClassName={classNames('jest-shelve-form-input', styles.input)}
              validationMessageExtraClassName="jest-shelve-form-input-error"
              errorList={errorList.name}
              isDisabled={isDisabled || isInProgress}
              isRequired
              isRequiredError={NEW_SHELVES_ERROR_MESSAGES.NAME_IS_REQUIRED}
              onUpdate={(input) => this.updateFormField(input)}
              label="Название полки"
              name="name" />
          </FormRow>
          <FormControl>
            <Button
              type="submit"
              extraClassName="jest-newShelve-form-submit"
              size="small"
              isInProgress={isInProgress}>
              Создать полку
            </Button>
          </FormControl>
        </Form>

      </React.Fragment>
    );
  }
};

NewShelveDialog.propTypes = {
  bookId: PropTypes.number,
  book: PropTypes.object,
  closeModal: PropTypes.func,
  gaEventLabel: PropTypes.string,
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
    payments: state.payments,
    offer: state.offer,
    booksPerSubscriptionCounter: state.booksPerSubscriptionCounter,
  };
};

const mapDispatchToProps = (dispatch) => ({
  BookDetailActions: bindActionCreators(BookDetailActions, dispatch),
  pop: (message, type) => dispatch(pop(message, type)),
});
export default connect(mapStateToProps, mapDispatchToProps)(NewShelveDialog);
